export {SimpleSearch} from "./simple-search.model";
export type {SimpleSearchInstance, Payload} from "./simple-search.model";
